"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataExplorerV2 = exports.queryMonitoringGraphTransactions = exports.queryMonitoringGraphEvents = exports.queryMonitoringGraphPage = exports.queryMonitoringGraphRevisitRate = exports.queryMonitoringGraphPagePerSession = exports.queryMonitoringGraphBounceRate = exports.queryCsatTotals = exports.queryCsatRatingsByValue = exports.queryCsatScores = exports.queryCsatQuestions = exports.queryCsatComments = exports.exportCsatData = exports.exportNpsData = exports.getQuota = exports.queryDataDryRun = exports.queryData = exports.getMetricFiltersV2 = exports.getFiltersV2 = exports.getMetricsV2 = exports.getDimensionsV2 = exports.dataExplorer = void 0;
const types_1 = require("../metrics/types");
const createApi_1 = require("../../helpers/createApi");
const types_2 = require("./types");
const TARGETING_CONDITIONS = __importStar(require("../audiences/types/conditions"));
const queryForm = (caller) => ({ account, startDate, endDate, metrics, dimensions, filtersValue, maxValue, sortMetrics, format }) => {
    const accountParam = `account=${account}`;
    const arrayParams = [
        {
            object: metrics,
            key: 'metrics[]',
        },
        {
            object: dimensions,
            key: 'dimensions[]',
        },
        {
            object: sortMetrics,
            key: 'sortMetrics[]',
        },
    ];
    const [metricsParams, dimensionsParams, sortMetricsParams] = arrayParams.map(({ object, key }) => {
        return object && object.length ? object.map((value) => `${key}=${value}`).join('&') : '';
    });
    const startDateParam = `startDate=${startDate}`;
    const endDateParam = `endDate=${endDate}`;
    const filtersValueParam = filtersValue ? `filtersValue=${filtersValue}` : '';
    const maxValueParam = maxValue ? `maxValue=${maxValue}` : '';
    const formatParam = format && `format=${format}`;
    const params = [
        accountParam,
        metricsParams,
        dimensionsParams,
        sortMetricsParams,
        startDateParam,
        endDateParam,
        filtersValueParam,
        maxValueParam,
        formatParam,
    ]
        .filter(Boolean)
        .join('&');
    return caller(`queryform/?${params}`).get();
};
const getMetrics = (caller) => () => caller('queryform/definition/metrics').get();
const getDimensions = (caller) => () => caller('queryform/definition/dimensions').get();
exports.dataExplorer = (0, createApi_1.createAPIFactory)({
    queryForm,
    getMetrics,
    getDimensions,
});
const getMonitoringData = (caller) => ({ accountId, startDate, endDate, goalType, goalId, campaignId, goalName, pageViewPath, operator }) => {
    const dimensions = ['variationId', 'date'];
    const timeIntervals = [
        {
            start: startDate,
            end: endDate,
        },
    ];
    const getOperatorString = (operator) => {
        switch (operator) {
            case TARGETING_CONDITIONS.EQUALS:
                return 'EQUAL';
            case TARGETING_CONDITIONS.REGEXP:
                return 'REGEXP';
            case TARGETING_CONDITIONS.CONTAINS:
                return 'CONTAINS';
            default:
                return 'CONTAINS';
        }
    };
    const getGoalSpecificFilter = ({ goalType, goalId }) => {
        switch (goalType) {
            case types_1.MetricType.Transaction:
                return [
                    {
                        key: 'transactionUserConversionRate',
                        filter: {
                            single: {
                                field: 'affiliation',
                                operator: 'EQUAL',
                                value: goalName,
                            },
                        },
                    },
                ];
            case types_1.MetricType.ActionTracking:
            case types_1.MetricType.CustomTracking:
                return [
                    {
                        key: 'uniqueEvents',
                        filter: {
                            single: {
                                field: 'eventAction',
                                operator: 'EQUAL',
                                value: goalName,
                            },
                        },
                    },
                    {
                        key: 'totalEvents',
                        filter: {
                            single: {
                                field: 'eventAction',
                                operator: 'EQUAL',
                                value: goalName,
                            },
                        },
                    },
                ];
            case types_1.MetricType.PageView:
                if (operator === TARGETING_CONDITIONS.IGNORE_PARAMETERS) {
                    return [
                        {
                            key: 'pageviewUserConversionRate',
                            filter: {
                                urlFilter: {
                                    value: pageViewPath,
                                    ignoreParameters: true,
                                },
                            },
                        },
                        {
                            key: 'pageviewSessionConversionRate',
                            filter: {
                                urlFilter: {
                                    value: pageViewPath,
                                    ignoreParameters: true,
                                },
                            },
                        },
                    ];
                }
                return [
                    {
                        key: 'pageviewUserConversionRate',
                        filter: {
                            single: {
                                field: 'url',
                                operator: getOperatorString(operator),
                                value: pageViewPath,
                            },
                        },
                    },
                    {
                        key: 'pageviewSessionConversionRate',
                        filter: {
                            single: {
                                field: 'url',
                                operator: getOperatorString(operator),
                                value: pageViewPath,
                            },
                        },
                    },
                ];
            case types_1.MetricType.BrowsingIndicator:
                switch (goalId) {
                    case types_1.IndicatorId.BounceRate:
                        return [{ key: 'bounceRate' }];
                    case types_1.IndicatorId.RevisitRate:
                        return [{ key: 'revisitRate' }];
                    case types_1.IndicatorId.NumberOfViewedPages:
                        return [{ key: 'pageviewsPerSession' }];
                }
            default:
                return [];
        }
    };
    const getMetric = ({ goalType, goalId }) => {
        if ([types_1.MetricType.ActionTracking, types_1.MetricType.CustomTracking, types_1.MetricType.PageView].includes(goalType)) {
            return [
                {
                    key: 'users',
                },
                {
                    key: 'sessions',
                },
            ];
        }
        return [
            {
                key: goalType === types_1.MetricType.Transaction || goalId === types_1.IndicatorId.RevisitRate ? 'users' : 'sessions',
            },
        ];
    };
    const metrics = [...getMetric({ goalType, goalId }), ...getGoalSpecificFilter({ goalType, goalId })];
    const orderBy = [
        {
            field: 'date',
        },
    ];
    const campaignFilter = {
        single: {
            field: 'campaignId',
            operator: 'EQUAL',
            value: campaignId,
        },
    };
    const body = {
        orderBy,
        metrics,
        campaignFilter,
        dimensions,
        timeIntervals,
        limit: 1000,
        business_rules: true,
    };
    return caller(`/v2/clients/${accountId}/query`).post(body, { headers: { 'x-context': 'dataviz' } });
};
const getDimensionsV2 = (caller) => ({ accountId }) => {
    return caller(`/v2/clients/${accountId}/supportedFields`).post({ fieldType: types_2.DataExplorerFieldType.Dimension });
};
exports.getDimensionsV2 = getDimensionsV2;
const getMetricsV2 = (caller) => ({ accountId }) => {
    return caller(`/v2/clients/${accountId}/supportedFields`).post({ fieldType: types_2.DataExplorerFieldType.Metric });
};
exports.getMetricsV2 = getMetricsV2;
const getFiltersV2 = (caller) => ({ accountId }) => {
    return caller(`/v2/clients/${accountId}/supportedFields`).post({ fieldType: types_2.DataExplorerFieldType.Filter });
};
exports.getFiltersV2 = getFiltersV2;
const getMetricFiltersV2 = (caller) => ({ accountId }) => {
    return caller(`/v2/clients/${accountId}/supportedFields`).post({ fieldType: types_2.DataExplorerFieldType.MetricFilter });
};
exports.getMetricFiltersV2 = getMetricFiltersV2;
const queryData = (caller) => ({ accountId, payload, headers }) => {
    return caller(`/v2/clients/${accountId}/query`).post(payload, { headers });
};
exports.queryData = queryData;
const queryDataDryRun = (caller) => ({ accountId, payload }) => {
    return caller(`/v2/clients/${accountId}/query/dryRun`).post(payload);
};
exports.queryDataDryRun = queryDataDryRun;
const getQuota = (caller) => ({ accountId }) => {
    return caller(`/v2/clients/${accountId}/quota`).get();
};
exports.getQuota = getQuota;
const queryTemplate = (caller) => (templateName) => ({ accountId, payload, isExport = false }) => {
    return caller(`/v2/clients/${accountId}/query-template/${templateName}`).post(payload, isExport ? { headers: { accept: 'text/csv' } } : {});
};
const exportNpsData = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.Nps);
exports.exportNpsData = exportNpsData;
const exportCsatData = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.Csat);
exports.exportCsatData = exportCsatData;
const queryCsatComments = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.CsatComments);
exports.queryCsatComments = queryCsatComments;
const queryCsatQuestions = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.CsatQuestions);
exports.queryCsatQuestions = queryCsatQuestions;
const queryCsatScores = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.CsatScores);
exports.queryCsatScores = queryCsatScores;
const queryCsatRatingsByValue = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.CsatRatings);
exports.queryCsatRatingsByValue = queryCsatRatingsByValue;
const queryCsatTotals = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.CsatTotals);
exports.queryCsatTotals = queryCsatTotals;
const queryMonitoringGraphBounceRate = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.MonitoringGraphBounceRate);
exports.queryMonitoringGraphBounceRate = queryMonitoringGraphBounceRate;
const queryMonitoringGraphPagePerSession = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.MonitoringGraphPagePerSession);
exports.queryMonitoringGraphPagePerSession = queryMonitoringGraphPagePerSession;
const queryMonitoringGraphRevisitRate = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.MonitoringGraphRevisitRate);
exports.queryMonitoringGraphRevisitRate = queryMonitoringGraphRevisitRate;
const queryMonitoringGraphPage = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.MonitoringGraphPage);
exports.queryMonitoringGraphPage = queryMonitoringGraphPage;
const queryMonitoringGraphEvents = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.MonitoringGraphEvents);
exports.queryMonitoringGraphEvents = queryMonitoringGraphEvents;
const queryMonitoringGraphTransactions = (caller) => queryTemplate(caller)(types_2.DataExplorerTemplateName.MonitoringGraphTransactions);
exports.queryMonitoringGraphTransactions = queryMonitoringGraphTransactions;
exports.dataExplorerV2 = (0, createApi_1.createAPIFactory)({
    getDimensionsV2: exports.getDimensionsV2,
    getMetricsV2: exports.getMetricsV2,
    getFiltersV2: exports.getFiltersV2,
    getMetricFiltersV2: exports.getMetricFiltersV2,
    queryData: exports.queryData,
    queryDataDryRun: exports.queryDataDryRun,
    queryCsatComments: exports.queryCsatComments,
    queryCsatQuestions: exports.queryCsatQuestions,
    queryCsatScores: exports.queryCsatScores,
    queryCsatRatingsByValue: exports.queryCsatRatingsByValue,
    queryCsatTotals: exports.queryCsatTotals,
    getMonitoringData,
    exportNpsData: exports.exportNpsData,
    exportCsatData: exports.exportCsatData,
    getQuota: exports.getQuota,
    queryMonitoringGraphBounceRate: exports.queryMonitoringGraphBounceRate,
    queryMonitoringGraphPagePerSession: exports.queryMonitoringGraphPagePerSession,
    queryMonitoringGraphRevisitRate: exports.queryMonitoringGraphRevisitRate,
    queryMonitoringGraphPage: exports.queryMonitoringGraphPage,
    queryMonitoringGraphEvents: exports.queryMonitoringGraphEvents,
    queryMonitoringGraphTransactions: exports.queryMonitoringGraphTransactions,
});
//# sourceMappingURL=api.js.map